export default (initialValue) => ({
    selectedIndex: initialValue,
})
